var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrivalMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "25px",
    viewBox: "0 0 64 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broker-Mode---Quote-Request",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-light/v3/-Bookings/Quote-Request/06.1-Declined-Oneway",
    transform: "translate(-1474.000000, -266.000000)",
    fill: "#19C0FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT-",
    transform: "translate(330.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin-on-map",
    transform: "translate(288.000000, 114.853662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(856.000000, 71.146338)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3-Copy",
    cx: 5,
    cy: 12,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L53,0 C55.209139,-8.49901461e-16 57,1.790861 57,4 L57,9.11230469 L57,9.11230469 L64,12.7954102 L57,16.4487305 L57,21 C57,23.209139 55.209139,25 53,25 L15,25 C12.790861,25 11,23.209139 11,21 L11,4 C11,1.790861 12.790861,4.05812251e-16 15,0 Z",
    id: "Rectangle",
    transform: "translate(37.500000, 12.500000) scale(-1, 1) translate(-37.500000, -12.500000) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalMapMarker);
export default __webpack_public_path__ + "static/media/arrival-map-marker.3a0e76e6.svg";
export { ForwardRef as ReactComponent };